<template>
  <div class="home">
    <page-title title="Dashboard" description="Overzicht van je ScAPP account - tijdelijke data"></page-title>



    <div class="card float-left m-2" style="width: 20rem;">
      <div class="card-body">
        <h5 class="card-title">omgeving: {{env}}</h5>
    </div>
    </div>


    <div class="card float-left m-2" style="width: 20rem;">
      <div class="card-body">
        <h5 class="card-title">ingelogd als: {{userProfile.firstname}} {{userProfile.lastname}}</h5>
    </div>
    </div>

  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from "@/components/PageTitle.vue";

import { mapState } from "vuex";

export default {
  name: "Home",
  components: {
    PageTitle,
  },
  computed: {
    ...mapState(["currentUser", "userProfile"])
  },
  data() {
    return {
      env: fb.env
    };
  },
  methods: {},
};
</script>
